module.exports = __webpack_public_path__ + "static/price_list_2018.c999b62a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/price_list_2018.pdf
// module id = 299
// module chunks = 35783957827783